import React from "react";
import "./standardbtn.scss";
import { Button } from "@mui/material";

const StandardBtn = ({
  className = 'btn-main ',
  onClick,
  disabled = false,
  loading = false,
  icon = null,
  loadingText = "",
  defaultText = "",
}) => {
  const mergedClassName = ["standard-btn", className].filter(Boolean).join(" ");

  return (
    <button className={mergedClassName} onClick={onClick} disabled={disabled}>
      <span className="ripos-cta-icon mb-2" aria-hidden="true">
        {icon}
      </span>
      <span>{loading ? loadingText : defaultText}</span>
    </button>
  );
};

export default StandardBtn;
